
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

  }

 getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }


    this.getSearchResults(this.searchTerm);
  }


onFormSubmit(event) {
  const form = event.target;
  const isInsideArticleWrapper = form.closest('.search-bar-article-wrapper') !== null;

  if (isInsideArticleWrapper && window.location.pathname.includes("/blogs/articulos")) {
    event.preventDefault();
  } else {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    }
  }
}

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    
    const currentSearchTerm = this.getQuery();
    //console.log("currentSearchTerm",currentSearchTerm);
    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      // this.getSearchResults(this.searchTerm);
    }
    if(document.querySelector(".drawer")){
    document.querySelector(".drawer").classList.remove('active');
    }
  }

  onFocusOut() {
    
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    
    // updateSubtitleCategoriesWithSearch(this,"/products.json");
    return ;
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    // console.log("newTerm", newTerm);
    
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

   selectOption() {
     const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
     if (selectedOption) selectedOption.click();
   }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,article&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        // console.log(response)
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        //console.log(text)
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
          //console.log(typeof(resultsMarkup))
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }
  
  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    //console.log("search clicked");
    this.setLiveRegionResults();
    
    const productItems = document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item');
    const totalItems = productItems.length;
    this.appendPagination(totalItems);

    //console.log("Total number of <li> tags:", totalItems);
    this.open();
  }


appendPagination(totalItems) {
  const totalPages = Math.ceil(totalItems / 6);
  //console.log("totalPages", totalPages);
  let currentPage = 1;

  // Ensure search categories exist before adding event listeners
  const searchCategories = document.querySelectorAll('.search-category');
  const paginationBox = document.querySelector('.pagination-container');

  let activeCategory = false;
  if (searchCategories.length > 0) {
    searchCategories.forEach(category => {
      category.addEventListener('click', function(event) {
       
        const dataTag = this.getAttribute('data-tag');
        activeCategory = false;
        searchCategories.forEach(category => {
          if (event.target.classList.contains('active')) {
              activeCategory = true;
          }
          category.classList.remove('active');
          paginationBox.classList.remove('hidden');
          
        });
        
        if(activeCategory == true){
         
          clearFilterButton.click()
          return;
          
        }else {
          this.classList.add('active');
          paginationBox.classList.add('hidden');
          const dataTagCount = this.getAttribute('data-tag-count');
          const productCountElement = document.querySelector('.product_Count span');
          if (productCountElement) {
            productCountElement.textContent = dataTagCount;
          }
          const wrapper = document.getElementById('search-collection-wrapper');
          if (wrapper) {
            wrapper.classList.add('clearfilter');
          }
          const items = document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item');
          items.forEach(item => {
            const itemTag = item.getAttribute('data-meta-tag');
            
            if (itemTag === dataTag) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
        });
        }
      });
    });
  }

  function updatePaginationButtons() {
    const prevButton = document.getElementById('previousPageButton');
    const firstButton = document.getElementById('firstPageButton');
    const nextButton = document.getElementById('nextPageButton');
    const lastButton = document.getElementById('lastPageButton');

    if (prevButton && firstButton && nextButton && lastButton) {
      if (currentPage === 1) {
        prevButton.classList.add('disabled');
        firstButton.classList.add('disabled');
      } else {
        prevButton.classList.remove('disabled');
        firstButton.classList.remove('disabled');
      }

      if (currentPage === totalPages) {
        nextButton.classList.add('disabled');
        lastButton.classList.add('disabled');
      } else {
        nextButton.classList.remove('disabled');
        lastButton.classList.remove('disabled');
      }
    }
  }


  // Add event listeners for pagination buttons if they exist
  const prevButton = document.getElementById('previousPageButton');
  const nextButton = document.getElementById('nextPageButton');
  const firstButton = document.getElementById('firstPageButton');
  const lastButton = document.getElementById('lastPageButton');

  if (prevButton) {
    prevButton.addEventListener('click', function() {
      if (currentPage > 1) {
        showPage(currentPage - 1);
        updatePaginationButtons();
      }
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function() {
      if (currentPage < totalPages) {
        showPage(currentPage + 1);
        updatePaginationButtons();
      }
    });
  }

  if (firstButton) {
    firstButton.addEventListener('click', function() {
      showPage(1);
      updatePaginationButtons();
    });
  }

  if (lastButton) {
    lastButton.addEventListener('click', function() {
      showPage(totalPages);
      updatePaginationButtons();
    });
  }

  updatePaginationButtons();

  const pageButtons = document.querySelectorAll('.page-number');
  if (pageButtons.length > 0) {
    
    pageButtons.forEach(pageButton => {
      pageButton.addEventListener('click', function() {
        pageButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        const clickedPage = this.getAttribute('data-page');
        if (clickedPage == "1") {
          showPage(1);
          updatePaginationButtons();
        } else if (clickedPage == totalPages) {
          showPage(totalPages);
          updatePaginationButtons();
        }
        document.querySelectorAll('.predictive-search__list-item').forEach(item => {
          
          const itemPage = item.getAttribute('data-page');
          if (itemPage === clickedPage) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
          updatePaginationButtons();
        });
      });
    });
  }

  const clearFilterButton = document.getElementById('clear-Filter');
  if (clearFilterButton) {
    clearFilterButton.addEventListener('click', function(event) {
      event.stopPropagation();
      showPage(1);
      searchCategories.forEach(category => {
        category.classList.remove('active');
      });
        
      const wrapper = document.getElementById('search-collection-wrapper');
      if (wrapper) {
        wrapper.classList.remove('clearfilter');
      }
      const productItems = document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item');
      const productCountElement = document.querySelector('.product_Count span');
      if (productCountElement) {
        productCountElement.textContent = productItems.length;
        
      }
      // Fixed the issue related to clearButton
      productItems.forEach(item => item.classList.remove('hidden')); // Show all items again
      if (paginationBox) paginationBox.classList.remove('hidden');  // Show pagination again
      currentPage = 1; // Reset current page
      showPage(currentPage); 
      const pageBtns = document.querySelectorAll('.page-number');
        pageBtns.forEach(btn => btn.classList.remove('active'));
        if (pageBtns.length > 0) {
          pageBtns[0].classList.add('active');
        }
      updatePaginationButtons(); // Update the button states
    });
  }
  
  
  function showPage(pageNumber) {
    currentPage = Math.max(1, Math.min(pageNumber, totalPages));
    const productItems = document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item');
    productItems.forEach(function(product) {
      const productPage = parseInt(product.getAttribute('data-page'));
      if (productPage === currentPage) {
        product.classList.remove('hidden');
      } else {
        product.classList.add('hidden');
      }
    });
  }
  showPage(1);
}





  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    
    this.resultsMaxHeight = Math.min(
            window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom,
            780
        );
    return this.resultsMaxHeight;
  }

  open() {
    document.querySelector('.search-overlay')?.classList.remove('hidden');
    var open_drawer = document.querySelector('#Details-menu-drawer-container[open]')
    if(open_drawer){
    open_drawer.removeAttribute('open');
     document.querySelector('.header__icon--menu[aria-expanded="true"]').setAttribute('aria-expanded', 'false');
    }
   
    document.querySelector('body').classList.add('overflow-hidden');
    
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    document.body.classList.add("predictive-search-open");
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    setTimeout(() => {
         document.body.classList.remove("predictive-search-open");
    }, 500);
  }

  closeResults(clearSearchTerm = false) {
    
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
    document.querySelector('.search-overlay')?.classList.add('hidden');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    // Add click event to all <product-form> elements inside this predictive-search instance
    this.addEventListener("click", (event) => {
    const productForm = event.target.closest("product-form");
    if (productForm) {
      setTimeout(() => {
          this.close(); 
    }, 500);
      
      }
  });

}


}
customElements.define('predictive-search', PredictiveSearch);
